export const ROUTES = {
  REPORTS: {
    INDEX: '/firehouse/reports',
    CALLBACK_REPORT: '/firehouse/reports/callback',
    PTO_REPORT: '/firehouse/reports/pto',
    PAYROLL_REPORT: '/firehouse/reports/payroll',
    PAYROLL_SUMMARY_REPORT: '/firehouse/reports/payroll-summary',
    OVERTIME_REPORT: '/firehouse/reports/overtime',
    OVERTIME_MASTER_REPORT: '/firehouse/reports/overtime-master',
    MUNIS_REPORT: '/firehouse/reports/munis',
    WEEKLY_PAYROLL_REPORT: '/firehouse/reports/weekly-payroll',
    SWAP_REPORT: '/firehouse/reports/swap-shifts',
    ADJUST_HOURS_REPORT: '/firehouse/reports/adjust-hours',
    AVAILABILITY_DETAIL_REPORT: '/firehouse/reports/availability-detail',
    AVAILABILITY_SUMMARY_REPORT: '/firehouse/reports/availability-summary',
    MILTON_REPORT: '/firehouse/reports/milton',
    HOLIDAY_REPORT: '/firehouse/reports/holiday',
    PTO_BALANCES: '/firehouse/reports/pto-balances',
    WOBURN_PAYBACK_REPORT: '/firehouse/reports/woburn-payback',
    WOBURN_OVERTIME_REPORT: '/firehouse/reports/woburn-overtime',
    WOBURN_REASSIGNMENT_REPORT: '/firehouse/reports/woburn-reassignment',
    WOBURN_PTO_REPORT: '/firehouse/reports/woburn-pto',
    WOBURN_MUNIS_PTO_REPORT: '/firehouse/reports/woburn-munis-pto',
    WOBURN_MUNIS_OVERTIME_REPORT: '/firehouse/reports/woburn-munis-overtime',
    ACCRUAL_BALANCE: '/firehouse/reports/accrual-balance',
  },
};
